module.exports = __webpack_public_path__ + "static/img/tangwan.20bac906.png";